export default __webpack_public_path__ + "static/media/agency.c02b225f.svg";